import { apiNeuronMeetCall } from "../api";

export async function createSpace({ user_id, customer_service_id }) {
  try {
    const { data } = await apiNeuronMeetCall.post(
      `/create-space?user_id=${user_id}&customer_service_id=${customer_service_id}`
    );
    return data;
  } catch (error) {
    return 400;
  }
}

export async function closeSpace(customer_service_id) {
  try {
    const { data } = await apiNeuronMeetCall.post(
      `/close-space?customer_service_id=${customer_service_id}`
    );
    return data;
  } catch (error) {
    return 400;
  }
}
